/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export interface ProjectParameterDataItems {
  projectParameterDataItems: ProjectParameterData;
}

export interface ProjectParameterData {
  discipline: string[];
  common: string[];
  structural: string[];
  hvac: string[];
  energy: string[];
  electrical: string[];
  piping: string[];
  infrastructure: string[];
}
